

























































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import numeral from 'numeral';

@Component
export default class PaymentHistory extends Vue {
    @Prop({ default: () => [] })
    private payments!: any[];

    @Prop({ default: 0 })
    private totalPaid!: number;

    @Prop({ default: 0 })
    private balanceDue!: number;

    @Prop({ default: null })
    private consigneeBankInfo?: any;

    private qrModalOpen: boolean = false;
    private qrImageUrl: string = '';
    private selectedPayment: any = null;
    private copiedField: string = '';

    private formatCurrency(val: number): string {
        if (!val) return '0 đ';
        return numeral(val).format('0,0') + ' đ';
    }

    private getStatusClass(st: string): string {
        switch (st) {
            case 'da_thanh_toan':
                return 'label-success';
            case 'cho_duyet':
                return 'label-warning';
            case 'da_huy':
                return 'label-danger';
            default:
                return 'label-default';
        }
    }

    private getBankName(pm: any): string {
        if (!pm) return '—';
        return pm.bank_account_short_name || pm.bank_account_name || (this.consigneeBankInfo && this.consigneeBankInfo.name);
    }

    private getAccountNumber(pm: any): string {
        if (!pm) return '—';
        return pm.bank_account_number;
    }

    private getAccountOwner(pm: any): string {
        if (!pm) return '—';
        return pm.bank_account_owner_name;
    }

    private getAccountDisplay(pm: any): string {
        if (!pm) return '';
        const name = pm.bank_account_short_name || pm.bank_account_name;
        return name;
    }

    private buildQrImageUrl(pm: any): string {
        if (!pm) return '';
        const bankName = pm.bank_account_name;
        const accNumber = pm.bank_account_number;
        const accName = pm.bank_account_owner_name;

        if (!bankName || !accNumber) return '';

        const amount = pm.amount || 0;
        const note = encodeURIComponent(pm.note || 'Thanh toan');
        const encodedAccName = encodeURIComponent(accName);
        return `https://api.vietqr.io/image/${bankName}-${accNumber}-xM1xYdA.jpg?amount=${amount}&addInfo=${note}&accountName=${encodedAccName}`;
    }

    private openQrModal(pm: any) {
        this.selectedPayment = pm;
        this.qrImageUrl = this.buildQrImageUrl(pm);
        this.copiedField = '';
        this.qrModalOpen = true;
    }

    private closeQrModal() {
        this.qrModalOpen = false;
        this.selectedPayment = null;
        this.qrImageUrl = '';
        this.copiedField = '';
    }

    private copyText(text: any, fieldKey: string) {
        if (!text) return;
        const str = String(text);
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(str).then(() => {
                this.copiedField = fieldKey;
                setTimeout(() => {
                    this.copiedField = '';
                }, 2000);
            }).catch(() => {
                this.fallbackCopyText(str, fieldKey);
            });
        } else {
            this.fallbackCopyText(str, fieldKey);
        }
    }

    private fallbackCopyText(text: string, fieldKey: string) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            document.execCommand('copy');
            this.copiedField = fieldKey;
            setTimeout(() => {
                this.copiedField = '';
            }, 2000);
        } catch (e) {
            // silent
        }
        document.body.removeChild(textArea);
    }
}
